<button kendoButton *ngIf="(auth.isAuthenticated$ | async) === false" [themeColor]="'primary'" (click)="loginWithRedirect()">
    Log in
</button>
<div *ngIf="auth.user$ | async as user" class="badge">
    <edit-lock />
    <feedback-form/>
    <kendo-dropdownbutton imageUrl="{{user.picture!}}" [data]="[{text:'Logout'}]" (itemClick)="this.logout()" class="badge-button">{{user.name}}</kendo-dropdownbutton>
    @if (this.apiService.isSercom()) {
        <translation-editor />

    }
</div>